interface MicLevelBarProps {
  /** Normalised audio level, 0–1. */
  level: number;
  /** Number of segments to render. Defaults to 12. */
  segments?: number;
}

export function MicLevelBar({ level, segments = 12 }: MicLevelBarProps) {
  const clamped = Math.max(0, Math.min(1, level));
  const active = Math.round(clamped * segments);

  return (
    <div
      role="meter"
      aria-label="Microphone level"
      aria-valuemin={0}
      aria-valuemax={1}
      aria-valuenow={Number(clamped.toFixed(2))}
      className="flex h-2 flex-1 items-stretch gap-[3px]"
    >
      {Array.from({ length: segments }).map((_, i) => {
        const isActive = i < active;
        const hue =
          i < segments * 0.65
            ? 'bg-[#35816E]'
            : i < segments * 0.85
              ? 'bg-[#6AA489]'
              : 'bg-[#D4A017]';
        return (
          <span
            key={i}
            className={`flex-1 rounded-[2px] transition-[background-color,transform] duration-100 ease-out ${
              isActive ? `${hue} scale-y-100` : 'scale-y-75 bg-white/8'
            }`}
          />
        );
      })}
    </div>
  );
}
